export const globalMessages = $state({
  infos: [] as string[],
  errors: [] as string[],
  warnings: [] as string[],
});
